import React, { useState, useEffect } from 'react'

import Axios from 'axios'

import FixtureTemplate from './FixtureTemplate'

function LiveFixturesByDate({
    leagueId,
    leagueName,
    leagueLogo,
    date,
    setIsLoading,
    type,
    isLoading,
    allFixturesByDate,
    leagueFixtures,
}) {
    const [fixtures, setFixtures] = useState([])
    const [show, setShow] = useState(true)

    const today = new Date()

    let day, month
    month = today.getMonth() + 1
    if (month < 10) {
        month = `0${month}`
    } else {
        month = month
    }
    if (today.getDate() < 10) {
        day = `0${today.getDate()}`
    } else {
        day = today.getDate()
    }

    function shortDate(date) {
        const dateFixtures = new Date(date)
        return dateFixtures.getDate() + '/' + (dateFixtures.getMonth() + 1)
    }

    function toggle() {
        if (show) {
            setShow(false)
        } else {
            setShow(true)
        }
    }

    useEffect(() => {
        setIsLoading(true)

        let dateFixtures
        if (date) {
            dateFixtures = date
        } else {
            dateFixtures = date
        }

        setFixtures(leagueFixtures)

        setIsLoading(false)
    }, [date, leagueFixtures])

    return (
        <React.Fragment>
            {fixtures?.length ? (
                <React.Fragment>
                    <div
                        className="card card-header bg-lightgrey"
                        style={{ cursor: 'pointer' }}
                        onClick={toggle}
                    >
                        <div style={{ fontSize: '0.8rem' }}>
                            <img
                                src={leagueLogo}
                                className="teamLogo"
                                alt={leagueName}
                            />{' '}
                            <span>{leagueName}</span>
                            <span className="float-right">
                                {shortDate(fixtures[0].event_date)}{' '}
                                <i
                                    className={
                                        show
                                            ? 'fas fa-chevron-down'
                                            : 'fas fa-chevron-up'
                                    }
                                ></i>
                            </span>
                        </div>
                    </div>
                    {show && (
                        <React.Fragment>
                            {fixtures?.map((fixture, index) => {
                                return (
                                    <FixtureTemplate
                                        key={index}
                                        fixture={fixture}
                                        type={type}
                                    />
                                )
                            })}
                        </React.Fragment>
                    )}
                </React.Fragment>
            ) : (
                ''
            )}
        </React.Fragment>
    )
}
export default LiveFixturesByDate
